import React from 'react';
import {
  Container,
  Paper,
  Box,
  Typography,
  Avatar,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Button,
  Chip,
} from '@mui/material';
import {
  Email as EmailIcon,
  AccessTime as AccessTimeIcon,
  Star as StarIcon,
  School as SchoolIcon,
} from '@mui/icons-material';
import { mockUser, mockCourses } from '../data/mockData';

const Profile = () => {
  const purchasedCourses = mockCourses.slice(0, 2); // Demo: first 2 courses are purchased

  return (
    <Container maxWidth="md">
      <Paper sx={{ p: 3, mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
          <Avatar
            sx={{
              width: 100,
              height: 100,
              mr: 3,
              bgcolor: 'primary.main',
              fontSize: '2.5rem',
            }}
          >
            {mockUser.name[0]}
          </Avatar>
          <Box>
            <Typography variant="h4" gutterBottom>
              {mockUser.name}
            </Typography>
            <Chip
              label={mockUser.subscription?.type === 'premium' ? 'Премиум' : 'Базовый'}
              color={mockUser.subscription?.type === 'premium' ? 'primary' : 'default'}
              size="small"
            />
          </Box>
        </Box>

        <Divider sx={{ my: 2 }} />

        <List>
          <ListItem>
            <ListItemIcon>
              <EmailIcon />
            </ListItemIcon>
            <ListItemText
              primary="Email"
              secondary={mockUser.email}
            />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <AccessTimeIcon />
            </ListItemIcon>
            <ListItemText
              primary="Подписка"
              secondary={`Действует до ${new Date(mockUser.subscription?.expiresAt || '').toLocaleDateString()}`}
            />
          </ListItem>
        </List>

        <Box sx={{ mt: 3 }}>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mb: 2 }}
          >
            {mockUser.subscription?.type === 'premium' ? 'Управление подпиской' : 'Улучшить до премиум'}
          </Button>
          <Button
            variant="outlined"
            color="primary"
            fullWidth
          >
            Настройки профиля
          </Button>
        </Box>
      </Paper>

      <Paper sx={{ p: 3 }}>
        <Typography variant="h5" gutterBottom>
          Мои курсы
        </Typography>
        <List>
          {purchasedCourses.map((course) => (
            <ListItem key={course.id}>
              <ListItemIcon>
                <SchoolIcon />
              </ListItemIcon>
              <ListItemText
                primary={course.title}
                secondary={`${course.duration} • ${course.lessons} уроков`}
              />
              <Chip
                icon={<StarIcon />}
                label={`${course.rating} ★`}
                color="primary"
                size="small"
              />
            </ListItem>
          ))}
        </List>
      </Paper>
    </Container>
  );
};

export default Profile; 